import React, {useEffect, useRef, useState} from "react"
import "./BrandArchiveList.scss"
import BrandArchiveListItem from "../BrandArchiveListItem/BrandArchiveListItem";
import {apiUrl} from "../../../constants/constants";
import useIntersectionObserver from "../../../utils/utils";
import Loading1 from "../../../../img/brandArchive/loadingAsset/loading1.svg"
import Loading2 from "../../../../img/brandArchive/loadingAsset/loading2.svg"
import Loading3 from "../../../../img/brandArchive/loadingAsset/loading3.svg"
import Loading4 from "../../../../img/brandArchive/loadingAsset/loading4.svg"
import Loading5 from "../../../../img/brandArchive/loadingAsset/loading5.svg"
import {flushSync} from "react-dom";

let interval;

function BrandArchiveList() {
    const [currentSize, setCurrentSize] = useState(8);
    const [observe, unobserve] = useIntersectionObserver(() => {
        setCurrentSize((page) => page + 8);
    });
    const [isLoading, setIsLoading] = useState(true)
    const [loadingImgCount, setLoadingImgCount] = useState(1)
    const target = useRef(null);
    const [totalElements, setTotalElements] = useState(10)
    const [brandArchiveList, setBrandArchiveList] = React.useState<any[]>([])
    const getBrandArchiveList = async () => {
        await setIsLoading(false)
        await fetch(apiUrl + `/api/boards/contents?page=1&size=${currentSize}`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            credentials: 'include'
        }).then(res => res.json()).then(response => {
            const resData = response.result
            setTotalElements(response.totalElements)
            setBrandArchiveList([...resData])
            setIsLoading(true)
        })
    }
    useEffect(() => {
        if (isLoading) {
            clearInterval(interval)
            unobserve(target.current);
        } else {
            let loadingTime = 1;
            interval = setInterval(() => {
                setLoadingImgCount(loadingTime)
                loadingTime++
                if (loadingTime === 6) {
                    loadingTime = 1
                }
            }, 200)
            observe(target.current);
        }
    }, [isLoading]);

    useEffect(() => {
        const N = brandArchiveList.length;
        if (0 === N || totalElements <= N) {
            unobserve(target.current);
        } else {
            observe(target.current)
        }
    }, [brandArchiveList]);

    useEffect(() => {
        if (currentSize !== 8) {
            getBrandArchiveList()
        }
    }, [currentSize])

    useEffect(() => {
        getBrandArchiveList()
    }, [])

    return (
        <div className="brand-archive-list-wrapper">
            <div className="brand-archive-list-title-wrapper">
                <div className="brand-archive-list-title">
                    Maker&apos;s Note
                </div>
                <div className="brand-archive-list-description">
                    좋은 분위기가 담긴 이야기와 제품을<br/>
                    만들고 있어요. 그 과정을 기록합니다.
                </div>
            </div>
            <div className={'brand-archive-list'}>
                {brandArchiveList?.map((item, index) => <BrandArchiveListItem key={index} item={item}/>)}
            </div>
            <div className="brand-archive-loading-wrapper" ref={target}>
                <div style={{display: isLoading === false ? "block" : "none"}}>
                    <img src={Loading1} style={{display: loadingImgCount === 1 ? "flex" : "none"}}/>
                    <img src={Loading2} style={{display: loadingImgCount === 2 ? "flex" : "none"}}/>
                    <img src={Loading3} style={{display: loadingImgCount === 3 ? "flex" : "none"}}/>
                    <img src={Loading4} style={{display: loadingImgCount === 4 ? "flex" : "none"}}/>
                    <img src={Loading5} style={{display: loadingImgCount === 5 ? "flex" : "none"}}/>
                </div>

            </div>
        </div>
    )
}

export default BrandArchiveList;
